import React from 'react';
import { ReactComponent as ContactIcon } from '../../assets/contact_icon.svg';
import './Contact.css';

type ContactProps = {
  label?: string;
};

const Contact: React.FC<ContactProps> = ({ label }) => {
  return (
    <div className="contact">
      <ContactIcon className="contact-icon" />
      {/* <span>{label}</span> */}
    </div>
  );
};

export default Contact;
